<article>
  <div class="form-side">
    <div class="submitting" *ngIf="submitting">
      <h1>Setting up your account...</h1>
      <p>Just a second while we get everything ready for you!</p>
      <app-spinner></app-spinner>

    </div>
    <ng-container *ngIf="!submitting">
      <h1 [innerHTML]="reason | markdownToHtml | trustHtml"></h1>
      <form (ngSubmit)="submit()" ngNativeValidate>
        <div class="signin-c2a">
          Already Have an Account? &nbsp; <a routerLink="/login">Sign In</a>
        </div>

        <error-message [host]="this"></error-message>
        <div class="input-container">
          <input required type="text" name="firstName" placeholder="First Name" autocomplete="given-name"
            [(ngModel)]="firstName" />
        </div>
        <div class="input-container">
          <input required pattern="^[^@]+@[^@]*\.[^@]*$" type="email" name="email" placeholder="Email Address"
            [(ngModel)]="email" />
        </div>
        <div class="input-container">
          <input required minlength="2" type="password" name="password" placeholder="Password"
            autocomplete="new-password" [(ngModel)]="password" />
        </div>
        <div class="input-container">
          <input type="number" autocomplete="address-line3" pattern="\d*" name="zip"
            placeholder="US Zip Code (Optional)" [(ngModel)]="zip" />
        </div>

        <div class="optin">
          <label>
            <input type="checkbox" name="terms" [(ngModel)]="newsletter">
            <div>
              Receive news and alerts and daily recaps from TYT. You may manage
              communication preferences and opt-out at any time.
            </div>
          </label>
        </div>

        <div style="text-align: center;">
          <re-captcha *ngIf="enableReCAPTCHA" [style.display]="'inline-block'" (resolved)="captchaSolved($event)"
            [siteKey]="recaptchaSiteKey"></re-captcha>

          <br />

          <button class="btn-2">Sign Up</button>
        </div>

        <ng-container *ngIf="extendedEmailNote">
          <br />
          <br />
          <div>
            <strong>Is your email address entered correctly?</strong><br />
            In order to ensure you can access your account after signup we have implemented
            additional checks for common mistakes. Check the message above for more information
            about why you are seeing this message.<br />
            <br />
            Double check the email address you have entered to be sure that you've entered it correctly.

            If you are sure it's entered correctly, you may have a legitimate email address
            which these checks don't account for.<br /><br />

            If you are sure your email address is entered correctly, contact support@tytnetwork.com and we'll
            help you get your account set up.
          </div>
        </ng-container>
      </form>

      <div class="signup-c2a">
        Or Sign Up With:
      </div>

      <div class="social-signups">
        <a *ngIf="enableYouTubeLogin" [href]="oauthUrlFor('youtube')" class="youtube" aria-label="Sign in with YouTube"
          title="Sign up with YouTube (and bring your YouTube Channel Membership to TYT.com!)">
          <i class="fab fa-youtube"></i>
          <img src="/assets/google_signin_buttons/yt_logo_mono_dark.png" />
        </a>
        <a [href]="oauthUrlFor('facebook')" class="facebook" aria-label="Sign in with Facebook">
          <i class="fab fa-facebook-f"></i>
          <span class="text">Facebook</span>
        </a>

        <a [href]="oauthUrlFor('twitter')" class="twitter" aria-label="Sign in with Twitter">
          <i class="fab fa-twitter"></i>
          <span class="text">Twitter</span>
        </a>
      </div>

      <div style="text-align: center; margin-top: 2em;">
        <a [href]="oauthUrlFor('google')" class="google" aria-label="Sign in with Google">
          <img style="height: 46px" src="/assets/google_signin_buttons/web/2x/btn_google_signin_dark_normal_web@2x.png"
            alt="Sign in with Google" />
        </a>
      </div>

      <div class="agreements">
        By signing up via any of the above methods, you agree to TYT's
        <a target="_blank" [href]="appConfig.accountsUrl + '/terms'">Terms of Use</a>
        , <a target="_blank" [href]="appConfig.accountsUrl + '/privacy'">Privacy Policy</a>
        and <a target="_blank" [href]="appConfig.accountsUrl + '/community-values'">Core Values</a>
      </div>

      <div class="extended-c2a-mobile">
        <br />
        <br />
        <div class="info-note">
          <strong>Why Register?</strong>
          <br />

          Register your free account to unlock these exclusive features:
          <ul>
            <li>Personalize TYT.com and the TYT apps to follow topics you're most interested in</li>
            <li>Track where you left off watching TYT programming across devices</li>
            <li>Sign petitions with one click</li>
            <li>More exclusive features coming soon!</li>
          </ul>
          Looking for TYT membership? <a routerLink="/membership-benefits">Click here</a>
        </div>
      </div>

    </ng-container>
  </div>
  <div class="value-prop-side">
    <div class="content-container">
      <h1 [innerHTML]="valuePropReason | markdownToHtml | trustHtml"></h1>

      <div class="issues">
        <div class="issue">
          <img src="/assets/signup-icons/green_deal.svg" />
          <div>
            The Green New Deal
          </div>
        </div>
        <div class="issue">
          <img src="/assets/signup-icons/medicare.svg" />
          <div>
            Medicare For All
          </div>
        </div>
        <div class="issue">
          <img src="/assets/signup-icons/college_for_all.svg" />
          <div>
            College For All
          </div>
        </div>
        <div class="issue">
          <img src="/assets/signup-icons/living_wage.svg" />
          <div>
            A Living Minimum Wage
          </div>
        </div>
        <div class="issue">
          <img src="/assets/signup-icons/banning_private.svg" />
          <div>
            Banning Private Financing For Elections
          </div>
        </div>
      </div>

      <br />
      <br />

      <div class="extended-c2a">
        <hr />

        Register your free account to unlock these exclusive features:
        <ul>
          <li>Personalize TYT.com and the TYT apps to follow topics you're most interested in</li>
          <li>Track where you left off watching TYT programming across devices</li>
          <li>Sign petitions with one click</li>
          <li>More exclusive features coming soon!</li>
        </ul>
        Looking for TYT membership? <a routerLink="/membership-benefits">Click here</a>
      </div>
    </div>
  </div>

</article>